import { render } from "./LogoHeader.vue?vue&type=template&id=c646cd56&scoped=true"
import script from "./LogoHeader.vue?vue&type=script&lang=js"
export * from "./LogoHeader.vue?vue&type=script&lang=js"

import "./LogoHeader.vue?vue&type=style&index=0&id=c646cd56&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c646cd56"]])

export default __exports__